import * as React from "react"
import ContactForm from "./dto/ContactForm";
import {FormBodyProps} from "../../common/props/FormBodyProps";
import InputFormGroup from "../../../hiberUiKit/src/molecules/FormGroup/InputFormGroup";
import Row from "../../layout/Row";
import Col from "../../layout/Col";
import SectionView from "../../layout/section/SectionView";
import MaskedDateInputFormGroup from "../../ui/form/MaskedDateInputFormGroup";
import MailFormGroup from "../table/MailFormGroup";
import PhoneFormGroup from "../../lead/form/component/PhoneFormGroup";
import ContactTitleEditor from "./ContactTitleEditor";
import ContactConsentFormGroup from "../../ui/form/ContactConsentFormGroup";
import BrandFormGroup from "../../user/form/BrandFormGroup";
import PartnerBrandFormGroup from "../../lead/form/PartnerBrandFormGroup";
import {FormField} from "../../../validation/FormField";
import {none} from "ts-option";
import CheckboxFormGroup from "../../ui/form/CheckboxFormGroup";

interface IComponentProps {
	editMode?: boolean
	archiveCheckboxEnabled?: boolean
}

type Props = FormBodyProps<ContactForm> & IComponentProps

/**
 * Individual contact form body.
 */
export default class IndividualContactFormBody extends React.Component<Props, {}> {
	public static partialProps: Partial<Props> = {
		editMode: false
	};

	render() {
		const brandFieldValue = this.props.form.brandId.getOptionalValue();

		return (
			<div>
				<SectionView>
					<Row customClass={"a-mb-20"}>
						<Col lg={2} xl={2}>
							<ContactTitleEditor label="Tile"
												placeholder="Title"
												field={this.props.form.title}
												focus={this.props.form.hasFocus(this.props.form.title)}
												onChange={field => this.props.onFieldChange(field)}/>
						</Col>
						<Col lg={5} xl={5}>
							<InputFormGroup label="First name"
											placeholder="Enter first name"
											field={this.props.form.firstName}
											focus={this.props.form.hasFocus(this.props.form.firstName)}
											onChange={field => this.props.onFieldChange(field)}/>
						</Col>
						<Col lg={5} xl={5}>
							<InputFormGroup label="Last name"
											placeholder="Enter last name"
											field={this.props.form.lastName}
											focus={this.props.form.hasFocus(this.props.form.lastName)}
											onChange={field => this.props.onFieldChange(field)}/>
						</Col>
					</Row>
					<Row customClass={"a-mb-20"}>
						<Col lg={6} xl={6}>
							<MaskedDateInputFormGroup label="Date of birth"
													  field={this.props.form.birthDate}
													  onChange={field => this.props.onFieldChange(field)}/>
						</Col>
						<Col lg={6} xl={6}>
							<MailFormGroup label="Email addresses:"
										   placeholder="Enter email address"
										   field={this.props.form.emails}
										   focus={this.props.form.hasFocus(this.props.form.emails)}
										   onChange={field => this.props.onFieldChange(field)}/>
						</Col>
					</Row>
					<Row customClass={"a-mb-20"}>
						<Col lg={6} xl={6}>
							<PhoneFormGroup field={this.props.form.phoneNumbers}
											onChange={this.props.onFieldChange}
											label={"Phone Number"}
											placeholder="Enter phone number"
											multi/>
						</Col>
					</Row>
					<Row>
						<Col lg={6} xl={6}>
							<BrandFormGroup label={"Brand"}
											placeholder="Select..."
											field={this.props.form.brandId}
											onChange={this.onBrandChange}
											disabled={this.props.editMode}/>
						</Col>
						<Col lg={6} xl={6}>
							<PartnerBrandFormGroup label="Partner brand"
												   placeholder="Select..."
												   field={this.props.form.partnerBrandId}
												   brandId={brandFieldValue}
												   disabled={brandFieldValue.isEmpty || this.props.editMode}
												   onChange={this.props.onFieldChange}/>
						</Col>
					</Row>
					{this.props.form.creationDateTime.getValue().isDefined &&
					<Row>
						<Col lg={6} xl={6}>
							<ContactConsentFormGroup consent={this.props.form.communicationConsent.getValue()}
													 date={this.props.form.creationDateTime.getValue()}
													 label={"Marketing opt-in"}/>
						</Col>
						<Col lg={6} xl={6}>
							<ContactConsentFormGroup consent={this.props.form.servicePlanRemindersConsent.getValue()}
													 date={this.props.form.creationDateTime.getValue()}
													 label={"Service Reminders"}/>
						</Col>
					</Row>}
					{this.props.editMode &&
					<Row>
						<Col lg={6} xl={6}>
							<CheckboxFormGroup field={this.props.form.archived}
											   onChange={this.props.onFieldChange}
											   label={"Archived"}
											   disabled={!this.props.archiveCheckboxEnabled}/>
						</Col>
					</Row>}
				</SectionView>
			</div>
		)
	}

	onBrandChange = (field: FormField<any>) => {
		this.props.onFieldsChange([field, this.props.form.partnerBrandId.updateValue(none)]);
	}
}